<template>
  <div class="guests-and-rooms">
    <div ref="header" class="guests-and-rooms-header">
      <header-close v-if="isAdultGuest" :back="getBack" />
      <h6 class="title">{{tc('booking.guestsAndRooms')}}</h6>
    </div>
    <div v-if="!isBookingEditMode" ref="notification" class="guests-and-rooms-notification">
      <span class="label">
        {{tc('booking.moreThenFiveRooms')}}
      </span>
      <span class="cta">
        <a href="#" @click.prevent="$emit('change-page', 'call-to-book')">{{tc('booking.call')}}</a>
      </span>
    </div>
    <div
      class="guests-and-rooms-body"
      :style="[{ height: scrollHeight + 'px' }]"
    >
      <guests-input
        v-model="query"
        index="1"
        :max-guests-allowed="maxGuestsAllowed"
        :selected-hotel="selectedHotel"
        @isDisabled="isDisabled = $event"
      />
      <guests-input
        v-for="(room, i) in query.aditionalGuests"
        :key="'room-' + i"
        is-aditional
        :index="i + 2"
        :max-guests-allowed="maxGuestsAllowed"
        :selected-hotel="selectedHotel"
        v-model="query.aditionalGuests[i]"
        @remove="removeRoom(i)"
      />
      <button
        v-if="!isBookingEditMode"
        class="add-room"
        :disabled="maxRoomsReached"
        @click="addRoom"
      >
        <span class="icon-plus"></span>
        <span class="label">{{tc('booking.addRoom')}}</span>
      </button>
    </div>
    <div ref="footer" class="guests-and-rooms-footer">
      <div class="confirmation-cta">
        <button
          :class="[{ loading: isLoading }]"
          @click="submit"
          :disabled="isDisabled"
        >
          {{tc('booking.updateGuestsAndRooms')}}
          <div
              class="sr-only"
              role="status"
            >
              {{ isLoading ? tc('accessibility.loadingButtonStatus') : '' }}
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'
import TabTrapMixin from '@mixins/tab-trap'
import HeaderClose from "../header-close/header-close.vue"
import GuestsInput from './components/guests-input.vue'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'guests-and-rooms',
  components: {
    HeaderClose,
    GuestsInput
  },
  mixins: [TabTrapMixin],
  inject: ['updateLocalQuery', 'localQuery'],
  data: () => ({
    isLoading: false,
    isDisabled: false,
    scrollHeight: 'auto',
    query: {}
  }),
  computed: {
    ...mapGetters('booking', ['getBookingTrackingV2']),
    ...mapState('responsive', { wHeight: 'height' }),
    ...mapGetters('hotelData', ['getHotelById']),
    ...mapGetters('i18n', ['tc']),
    ...mapState('modifyReservation', ['isBookingEditMode']),
    maxRoomsAllowed() {
      return 5
    },
    maxRoomsReached() {
      return this.query.roomQuantity >= this.maxRoomsAllowed
    },
    maxGuestsAllowed() {
      return Number(this.selectedHotel.maxGuestsAllowed) || 5
    },
    selectedHotel() {
      return this.getHotelById(this.query.hotelCode)
    },
    isAdultGuest() {
      return this.localQuery.adultGuestCount
    }
  },
  watch: {
    wHeight(val) {
      this.calculateScroll()
    }
  },
  created() {
    this.query = cloneDeep(this.localQuery)
  },
  mounted() {
    this.calculateScroll()
    this.$track(this.getBookingTrackingV2(this.localQuery, {'event': 'cartView'}))
    this.$track(
      this.getBookingTrackingV2(this.localQuery, {
        event: "bookingStateChange",
        bookingEngine: {
          bookingStepNumber: '1.4',
          bookingStepName: 'Guests & Rooms Update',
          bookingEngineVersion: '1'
        },
      })
    );
    
    if (window.adobe?.target?.triggerView) {
      window.adobe.target.triggerView('Guests & Rooms Update')
    }
  },
  methods: {
    getBack() {
      this.$emit('change-page', 'confirmation')
    },
    calculateScroll() {
      const footerHeight = this.$refs.footer?.getBoundingClientRect().height || 0
      const headerHeight = this.$refs.header?.getBoundingClientRect().height || 0
      const notificationHeight = this.$refs.notification?.getBoundingClientRect().height || 0
      this.scrollHeight = this.wHeight - footerHeight - headerHeight - notificationHeight
    },
    addRoom() {
      this.query.roomQuantity++
      this.query.aditionalGuests.push({
        adultGuestCount: 2,
        childGuestCount: 0,
        hotelCode: this.query.hotelCode
      })
    },
    removeRoom(index) {
      this.query.roomQuantity--
      this.query.aditionalGuests.splice(index, 1)
    },
    submit() {
      this.isLoading = true
      if (this.query.roomQuantity > this.maxRoomsAllowed || this.query.aditionalGuests.length > this.maxRoomsAllowed - 1) {
        this.isLoading = false
        throw new Error('number of rooms not allowed')
      }
      this.updateLocalQuery({ prop: 'adultGuestCount', value: this.query.adultGuestCount })
      this.updateLocalQuery({ prop: 'childGuestCount', value: this.query.childGuestCount })
      this.updateLocalQuery({ prop: 'roomQuantity', value: this.query.roomQuantity })
      this.updateLocalQuery({ prop: 'aditionalGuests', value: this.query.aditionalGuests })
      this.getBack()
      this.isLoading = false
    }
  }
}
</script>
